<button (click)="follow()" class="sm light btn-red-ol" [class.btn-red-ol]="!following" [class.btn-red]="following">
    {{ following?'siguiendo':'seguir' }}
</button>